/*
 * Filename: d:\projects\AutoFiFront\src\Content\Car\CarElement\CarElement.type.ts
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, February 2nd 2023, 9:50:31 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import Config from "Config/Config";

class CarCost {
  public carCost = 0;
  public CustomText = "";

  public fromJson(jsonObj: any) {
    this.carCost = parseInt(jsonObj.InSell[0].SellPrice);
    this.CustomText = jsonObj.InSell[0].CustomText ?? "";
  }
}

class IconSubSection {
  IconSubSection = "";

  public fromJson(jsonObj: any) {
    this.IconSubSection = jsonObj.SubSection;
  }
}

class CarInfo {
  public Status = "";
  public Brand = "";
  public Model = "";
  public Version = "";
  public Mileage = 0;
  public CirculationDate: Date = new Date();
  public Gears = "";
  public Energy = "";
  public RegNb = "";
  public SellPrice = 0;
  public Color = "";
  public Link = "";
  public RepairCost = 0;
  public Comments = "";
  public StoragePlace: {
    City: string;
    Country: string;
    PostalCode: string;
  } = {
    City: "",
    Country: "",
    PostalCode: "",
  };
  public CarType: {
    Name: string;
  } = {
    Name: "",
  };

  public fromJson(jsonObj: any) {
    const badValues: (string | null | undefined)[] = [undefined, null, ""];

    this.Status = jsonObj.InSell[0].Status;
    this.Brand = jsonObj.Brand;
    this.Model = jsonObj.Model;
    this.Version = jsonObj.Version;
    this.RegNb = jsonObj.RegNb;
    this.Mileage = parseInt(jsonObj.InSell[0].Mileage);
    this.CirculationDate = new Date(jsonObj.CirculationDate);
    this.Gears = jsonObj.Gears;
    this.Comments = jsonObj.Comments;
    this.SellPrice = jsonObj.InSell[0].SellPrice;
    this.Color = badValues.includes(jsonObj.Color) ? "N/A" : jsonObj.Color;
    this.Link = jsonObj.Link;
    this.Energy = jsonObj.Energy.Name;
    this.StoragePlace = jsonObj.InSell[0].StoragePlace;
    this.RepairCost = jsonObj.InSell[0].RepairVal ?? 0;
    this.CarType = jsonObj.CarType;
  }
}

class CarImg {
  public url: string = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GET_PICTURE}`;
  public status = "";
  public subSection = "";

  public fromJson(jsonObj: any) {
    this.url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GET_PICTURE}${jsonObj.id}`;
    this.status = jsonObj.InSell[0].Status;
    this.subSection = jsonObj.SubSection;
  }
}

export class SingleCarFormat {
  public id = "";
  public carCost: CarCost = new CarCost();
  public carInfo: CarInfo = new CarInfo();
  public iconSubSection: IconSubSection = new IconSubSection();
  public carImg: CarImg = new CarImg();

  public fromJson(jsonObj: any): void {
    this.id = jsonObj.id;
    this.carCost.fromJson(jsonObj);
    this.iconSubSection.fromJson(jsonObj);
    this.carInfo.fromJson(jsonObj);
    this.carImg.fromJson(jsonObj);
  }
}
